export default function (request, { urltemplate, server }) {
  const prefix = `${server.API_SERVER}/c`

  return {
    getTrafficStats ({ params }) {
      return request({
        url: urltemplate(`${prefix}/users/:userId/traffic/actions/stats`, params),
        method: 'get'
      })
    },

    getTrafficChartData ({ params, query }) {
      return request({
        url: urltemplate(`${prefix}/users/:userId/traffic`, params),
        method: 'get',
        params: query
      })
    },

    getTrafficDetail ({ params, query }) {
      return request({
        url: urltemplate(`${prefix}/users/:userId/traffic/details`, params),
        method: 'get',
        params: query
      })
    }

  }
}
